var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 59,
    viewBox: "0 0 86 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9223 53H3.07772C1.37794 53 0 54.3431 0 56C0 57.6569 1.37794 59 3.07772 59H50.9223C52.6221 59 54 57.6569 54 56C54 54.3431 52.6221 53 50.9223 53Z",
    fill: "#EBEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 37.233V59H43.2812V37.233H54ZM38.7188 21V59H28V21H38.7188Z",
    fill: "#D7DAE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86 0H74V59H86V0Z",
    fill: "#EBEDF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19H74V59H86V19Z",
    fill: "#D7DAE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71 23H59V59H71V23Z",
    fill: "#EBEDF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71 59H59V29H71V59Z",
    fill: "#D7DAE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryFileIcon);
export default __webpack_public_path__ + "static/media/summaryFileIcon.fa313691a7a4308c85881a8d6434d936.svg";
export { ForwardRef as ReactComponent };